


























































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import ErrorController from "@/resources/mixins/errorController/errorController";
import { Validate } from "vuelidate-property-decorators";
import { required, email, url, sameAs } from "vuelidate/lib/validators";
import { UserInterface } from "@/resources/interfaces/userInterfaces";
import { i18n } from "@/resources/locales";
import { TIME_ZONE_EN } from "@/resources/constants/timeZone.en";
import { TIME_ZONE_ES } from "@/resources/constants/timeZones.es";
import { MAX_SIZE_FILE } from "@/resources/constants/system";
import ImageCropComponent from "@/app/components/imageCrop/imageCrop.component.vue";
import { MIX_PANEL_CONSTANTS } from "@/resources/constants/mixpanel";
import callback from "pusher-js/types/src/core/events/callback";
import { LANGUAGES } from "@/resources/constants/userLanguages";
@Component({
  name: "profile-onboarding-component",
  components: { ImageCropComponent },
})
export default class ProfileOnBoardingComponent extends mixins(
  UserValidator,
  ErrorController
) {
  LANGUAGES = LANGUAGES;
  @Validate({ required })
  name = "";
  @Validate({ required, email })
  email = "";
  @Validate({ required })
  timezone = "";
  @Validate({ url })
  linkedin = "";
  @Validate({ url })
  twitter = "";
  @Validate({ email })
  socialEmail = "";
  @Validate({ required })
  password = "";
  @Validate({
    required,
    sameAs: sameAs("password"),
  })
  confirmPassword = "";
  lastName = "";
  city = "";
  occupation = "";
  myMotto = "";
  biography = "";
  timeZoneList = i18n.locale === "en" ? TIME_ZONE_EN : TIME_ZONE_ES;

  loading = false;

  hasVisiblePassword = false;
  loadingEmail = false;
  noData = true;
  profileImage = [];
  languages = [];
  filePreview = "";
  img = "";
  openCrop = false;
  mounted() {
    this.loading = true;
    this.$store.dispatch("UserStore/getUserAction", {
      callback: async (data) => {
        this.loading = false;
        this.name = data.name && data.name !== "noname" ? data.name : "";
        this.lastName = data.lastName;
        this.email = data.email;
        this.timezone =
          data.timezone != null ? data.timezone : this.getTimeZone();
        this.city = data.city ? data.city : this.getTimeZone().split("/")[1];
        this.occupation = data.occupation;
        this.myMotto = data.myMotto;
        this.biography = data.biography;
        this.linkedin = data.linkedin;
        this.twitter = data.twitter;
        this.socialEmail = data.socialEmail;
        this.languages = data.languages || [];
        this.noData = false;
      },
    });
    setTimeout(() => {
      const select = document.getElementsByClassName("vs-select__input");
      const inputSelect = select[0];
      if (inputSelect instanceof HTMLInputElement) {
        inputSelect.placeholder = i18n.t("labels.search").toString();
      }
    }, 1000);
  }
  get user(): UserInterface {
    return this.$store.getters["UserStore/getUser"];
  }
  get active() {
    return (
      this.$store.getters["FloatMenuStore/getOpenProfile"] && this.onBoarding()
    );
  }
  set active(e) {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", e);
  }
  get activeCrop() {
    return this.openCrop;
  }
  set activeCrop(e) {
    this.openCrop = e;
  }
  getTimeZone(): string {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timezone ? timezone : "America/New_York";
  }
  destroyed(): void {
    this.loadTextOnBoarding();
  }
  loadTextOnBoarding(): void {
    if (this.onBoarding()) {
      this.$store?.dispatch("SystemStore/setTutorialTextAction", 0);
    }
  }
  closeDialog(): void {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", false);
  }
  onBoarding(): any {
    return this.$store.getters["SystemStore/getShowCompleteOnBoarding"];
  }
  updateUserEmail(): void {
    this.loadingEmail = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        email: this.email,
      },
      callback: (user) => {
        this.loadingEmail = false;
        this.onSuccess(
          i18n.t("notifications.titles.success"),
          i18n.t("notifications.descriptions.userUpdate")
        );
        this.$store.dispatch("SpaceStore/updateUserInSpace", user);
      },
      callbackError: (error) => {
        this.loadingEmail = false;
        if (error.response && error.response.status == 422)
          this.checkError(error);
        else
          this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  skipStep() {
    this.$store.dispatch("FloatMenuStore/setOpenProfileAction", false);
  }
  updateUserData(): void {
    this.loading = true;
    this.$store.dispatch("UserStore/updateUserAction", {
      userId: this.user.id,
      props: {
        name: this.name,
        lastName: this.lastName,
        timezone: this.timezone,
        city: this.city,
        occupation: this.occupation,
        myMotto: this.myMotto,
        biography: this.biography,
        linkedin: this.linkedin,
        languages: this.languages,
        twitter: this.twitter,
        socialEmail: this.socialEmail,
        plainPassword: this.password,
      },
      callback: (user) => {
        if (this.profileImage.length > 0) {
          this.uploadFile();
        }
        this.loading = false;
        const space = this.$store.getters["SpaceStore/getSpace"];
        this.$store.dispatch("UserStore/getSpaceUserAction", {
          spaceId: space.id,
          callback: (user) => {
            this.$store.dispatch(
              "SpaceStore/updateUserInSpace",
              user.superSpaceUser.user
            );
            this.$store.dispatch("FloatMenuStore/setOpenProfileAction", false);
            this.$store.dispatch("GraphicClientStore/updateUser", user);
            const hasOnboarding = !localStorage.getItem("hasOnboarding")
              ? true
              : localStorage.getItem("hasOnboarding") === "true";
            if (!hasOnboarding) {
              this.$store.dispatch("UserStore/updateUserAction", {
                userId: this.user.id,
                props: {
                  isFirstTime: false,
                },
                callback: () => {
                  this.$store.dispatch(
                    "MeetingStore/setOpenDevicesConfigAction",
                    true
                  );
                  this.$store.dispatch(
                    "SystemStore/setShowCompleteOnBoardingAction",
                    false
                  );
                  this.$store.dispatch(
                    "SystemStore/setShowCompleteOnBoardingTeamsAction",
                    false
                  );
                  this.$store?.dispatch(
                    "SystemStore/setShowTutorialModalAction",
                    false
                  );
                },
              });
            }
          },
        });
      },
      callbackError: (error) => {
        this.loading = false;
        this.onError("", i18n.t("notifications.errorMessages.updatePerfil"));
      },
    });
  }
  selectFile(): void {
    if (this.$refs.file["files"][0].size >= MAX_SIZE_FILE) {
      this.onError(
        this.$i18n.t("notifications.titles.error"),
        this.$i18n.t("notifications.errorMessages.maxFileSize")
      );
      return;
    }
    if (this.$refs.file["files"].length > 0) {
      this.profileImage = this.$refs.file["files"];

      this.active = true;
      this.openCrop = true;
      const fr = new FileReader();
      setTimeout(() => {
        const img = document.getElementById("preview-image");
        fr.onload = (event) => {
          if (event) {
            if (img instanceof HTMLImageElement) {
              this.filePreview = event ? event?.target.result.toString() : "";
              this.img = event ? event?.target.result.toString() : "";
            }
          }
        };
        fr.readAsDataURL(this.profileImage[0]);
      }, 200);
    }
  }
  uploadFile(): void {
    const formData = new FormData();
    if (this.profileImage) {
      formData.append("file", this.dataURItoBlob(this.filePreview) || "");
      this.$store.dispatch("UserStore/uploadUserProfileImageAction", {
        data: formData,
        callback: () => {
          this.loading = false;
          /*if (!this.onBoarding()) {
            this.onSuccess(
              i18n.t("notifications.titles.success"),
              i18n.t("notifications.descriptions.userUpdate")
            );
          }*/
        },
        callbackError: (error) => {
          console.log("uploadFile callbackError ", error);
        },
      });
    }
  }
  dataURItoBlob(dataURI): Blob {
    const binary = atob(dataURI.split(",")[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }
  getProgress(value: string): number {
    let progress = 0;

    // more than 5 digits
    if (value.length >= 6) {
      progress += 20;
      // at least one number
      if (/\d/.test(value)) {
        progress += 20;
      }
      if (/(.*[A-Z].*)/.test(value)) {
        progress += 20;
      }
      // at menons a lowercase
      if (/(.*[a-z].*)/.test(value)) {
        progress += 20;
      }
      // at least one special character
      if (/[^A-Za-z0-9]/.test(value)) {
        progress += 20;
      }
    } else if (value.length > 1) {
      progress = 20;
    }

    return progress;
  }
}
